import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../static/images/logo.png';
import Facet from '../../components/Brand/Facet';
import './auth.css';

const SPEC = [
  { k: 'Taxa', v: 'R$ 0,50 por venda' },
  { k: 'Recebe', v: 'PIX · Cartão · 130 moedas' },
  { k: 'Entrega', v: 'Acesso liberado sozinho, 24/7' },
];

/* ---------------------------------------------------------------- */
/* Shell — painel da marca (esquerda) e formulário (direita).        */
/* Abas Entrar/Criar conta só nas telas de login e cadastro.         */
/* ---------------------------------------------------------------- */
export default function AuthShell({ active, title, children }) {
  const hasTabs = active === 'login' || active === 'register';

  return (
    <div className="sp-auth-root">
      <aside className="sp-auth-brand">
        <Link to="/" className="sp-auth-logo" aria-label="Spectrum — página inicial">
          <img src={logo} alt="Spectrum" />
        </Link>

        <Facet className="sp-facet" />

        <div className="sp-brand-copy">
          <p className="sp-kicker sp-in sp-in-1">Automação de vendas no Telegram</p>
          <h1 className="sp-brand-title sp-in sp-in-2">{title}</h1>
          <dl className="sp-spec sp-in sp-in-3">
            {SPEC.map((row) => (
              <div key={row.k} className="sp-spec-row">
                <dt>{row.k}</dt>
                <dd>{row.v}</dd>
              </div>
            ))}
          </dl>
        </div>
      </aside>

      <main className="sp-auth-panel">
        <div className="sp-card sp-in sp-in-2">
          {hasTabs && (
            <nav className="sp-card-tabs" aria-label="Acesso">
              <Link to="/login" aria-current={active === 'login' ? 'page' : undefined}
                className={`sp-card-tab ${active === 'login' ? 'active' : ''}`}>
                Entrar
              </Link>
              <Link to="/register" aria-current={active === 'register' ? 'page' : undefined}
                className={`sp-card-tab ${active === 'register' ? 'active' : ''}`}>
                Criar conta
              </Link>
            </nav>
          )}

          {children}
        </div>

        {/* No cadastro os termos já aparecem acima do botão: não repete aqui. */}
        <p className="sp-panel-foot">
          © Spectrum
          {active !== 'register' && (
            <> · <Link to="/legal/tos" className="sp-link-quiet">Termos de Uso</Link></>
          )}
        </p>
      </main>
    </div>
  );
}
